module.exports = __webpack_public_path__ + "static/img/sm_24.a87e69e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/sm_24.png
// module id = vnPj
// module chunks = 0